import axios from 'axios';

const voterService = {
  async get(idElection, voterIdentifier) {
    const url = `/placevoting/${idElection}/${voterIdentifier}`;
    const response = await axios.get(url);
    if (response.data.status === 'ok') {
      return response.data;
    } else {
      throw new Error(response.data);
    }
  },
  savePassElector(credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post('/savePass', credentials)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  sendPasswordResetRequest(jsonObject) {
    const url = '/voter/passwordresetsolicitation';
    return new Promise((resolve, reject) => {
      axios
        .post(url, jsonObject)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  verifyKeyResetPassword(jsonObject) {
    const url = '/voter/keyverification';
    return new Promise((resolve, reject) => {
      axios
        .post(url, jsonObject)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  sendPasswordResetExecution(jsonObject) {
    const url = '/voter/passwordchange';
    return new Promise((resolve, reject) => {
      axios
        .post(url, jsonObject)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

export default voterService;
